import classNames from 'classnames'
import { useParams } from 'next/navigation'
import React, { useState } from 'react'
import styles from './AddressPicker.module.scss'
import { useLocalisation } from '@/tools/i18n/client'
import { Button, ButtonSize, ButtonVariants, ChevronDownIcon, LocationMarkerIcon } from '@/tools/ui'
import { AddressBookModal } from '@/user/address-book'

interface Props {
  addressText: string | undefined
  color?: string
  showLocationScrollDrawer: boolean
  centered?: boolean
}

export const AddressPicker: React.FC<Props> = ({
  addressText,
  color,
  showLocationScrollDrawer,
  centered,
}) => {
  const { city } = useParams()
  const { t } = useLocalisation()
  const [isOpenAddressBook, setIsOpenAddressBook] = useState(false)
  const isBrandHeader = color === 'brand'
  const shouldShowCoachmark = !isBrandHeader && city
  const addressPrompt = shouldShowCoachmark ? (
    <span className={styles.addressPrompt}>{city}</span>
  ) : (
    t('address.input-placeholder')
  )

  const handleOpenAddressBook = () => {
    setIsOpenAddressBook(!isOpenAddressBook)
    return
  }

  const handleCloseAddressBook = () => {
    setIsOpenAddressBook(false)
  }

  return (
    <div
      className={classNames(styles.addressPicker, {
        [styles.centered]: centered,
      })}
    >
      {!showLocationScrollDrawer && (
        <Button
          className={styles.addressButton}
          leadingIcon={LocationMarkerIcon}
          size={ButtonSize.small}
          trailingIcon={ChevronDownIcon}
          variant={ButtonVariants.neutral}
          onClick={handleOpenAddressBook}
        >
          {addressText || addressPrompt}
        </Button>
      )}
      <AddressBookModal
        isOpen={isOpenAddressBook}
        onClose={handleCloseAddressBook}
        onSelect={handleCloseAddressBook}
      />
    </div>
  )
}
